<template>
  <b-container class="admin-category-container">
    <b-card header="產品分類管理">
      <b-list-group>
        <b-list-group-item
          href="#"
          @click="showModal"
        >
          <b-icon-plus-square-fill />
          新增分類
        </b-list-group-item>
        <b-list-group-item
          v-b-tooltip.hover.right="{ variant: 'info' }"
          class="categoryItem"
          title="編輯此分類"
          href="#"
          v-for="cate in categories"
          :key="cate.id"
          @click="showEdit(cate.id)"
        >
          <span>
            <img
              v-if="cate.iconPath"
              :src="cate.iconPath"
              :alt="cate.icon"
            >
          </span>
          {{ cate.name_CH }} ({{ cate.name_EN }})
        </b-list-group-item>
      </b-list-group>
    </b-card>

    <b-modal
      id="modal-1"
      :title="mode === 'Create' ? '新增分類' : '編輯分類'"
      hide-footer
    >
      <b-form
        class="editModal"
        @reset="resetData"
        @submit="submitData"
      >
        <b-form-group
          id="input-group-1"
          label="分類 Icon:"
          label-for="file-1"
          description="請選擇該分類的.svg圖檔"
        >
          <b-form-file
            id="file-1"
            v-model="formData.iconImage"
            :state="Boolean(formData.iconImage || formData.icon)"
            browse-text="瀏覽"
            accept=".svg"
            :required="!Boolean(formData.iconImage || formData.icon)"
            :placeholder="formData.icon || '選擇檔案...'"
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="分類 Banner:"
          label-for="file-2"
        >
          <div
            class="preview"
            @click="$refs.fileUpload.click()"
          >
            <h3 v-if="!previewURL">請選擇上傳圖片</h3>
            <img
              v-else
              :src="previewURL"
            >
          </div>

          <input
            @change="onFileSelected"
            ref="fileUpload"
            style="display:none"
            type="file"
            name="banner"
          >
        </b-form-group>

        <b-form-group
          id="input-group-3"
          :label="`中文分類名稱:${Object.keys(categoryFilterById).length && categoryFilterById.order !== 10 ? '(此為原生分類故無法修改名稱)' : ''}`"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="formData.name_CH"
            type="text"
            required
            :disabled="Boolean(Object.keys(categoryFilterById).length && categoryFilterById.order !== 10)"
            placeholder="輸入分類名稱"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-4"
          :label="`英文分類名稱:${Object.keys(categoryFilterById).length && categoryFilterById.order !== 10 ? '(此為原生分類故無法修改名稱)' : ''}`"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="formData.name_EN"
            type="text"
            required
            :disabled="Boolean(Object.keys(categoryFilterById).length && categoryFilterById.order !== 10)"
            placeholder="輸入分類名稱"
          ></b-form-input>
        </b-form-group>

        <section
          class="modal-btn-group"
          v-if="!loading"
        >
          <b-button
            :style="{'margin-right': '16px'}"
            type="submit"
            variant="primary"
          >{{ mode === 'Create' ? '建立' : '更新' }}</b-button>
          <b-button type="reset" v-if="!Object.keys(categoryFilterById).length || categoryFilterById.order === 10">重設</b-button>

          <b-button
            v-if="categoryFilterById.order === 10"
            @click="deleteData"
            variant="danger"
          >刪除</b-button>
        </section>

        <section v-else>
          <b-spinner label="Spinning"></b-spinner>
          <p>上傳中...</p>
        </section>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
  import { mapState, mapActions } from "vuex";

  export default {
    data() {
      return {
        formData: {},
        mode: "Create",
        focusId: "",
        previewURL: "",
        loading: false,
      };
    },
    computed: {
      ...mapState("backend", ["categories"]),

      categoryFilterById: function () {
        if (this.categories.length && this.focusId) {
          return this.categories.filter((cate) => cate.id === this.focusId)[0];
        }
        return {};
      },
    },
    methods: {
      ...mapActions("backend", ["addCategory", "editCategory", "deleteCategory"]),

      showModal: function () {
        this.$bvModal.show("modal-1");
        this.mode = "Create";
        this.focusId = "";
        this.resetData();
      },
      showEdit: function (id) {
        this.$bvModal.show("modal-1");
        this.mode = "Edit";
        this.focusId = id;
      },
      resetData: function () {
        this.formData = {};
        this.previewURL = "";
      },
      submitData: async function (e) {
        e.preventDefault();
        this.loading = true;
        let response;
        if (this.mode === "Create") {
          response = await this.addCategory({ ...this.formData });
        } else {
          response = await this.editCategory({
            id: this.focusId,
            ...this.formData,
          });
        }
        if (response) {
          this.$bvModal.hide("modal-1");
          this.loading = false;
          this.focusId = "";
          this.resetData();
        }
      },
      deleteData: async function () {
        if (confirm("確定要刪除此分類嗎?")) {
          const response = await this.deleteCategory({
            id: this.focusId,
            ...this.formData,
          });
          if (response) {
            this.$bvModal.hide("modal-1");
            this.loading = false;
            this.focusId = "";
            this.resetData();
          }
        }
      },
      onFileSelected: function (event) {
        this.formData.image = event.target.files[0];
        this.previewURL = URL.createObjectURL(this.formData.image);
      },
    },
    watch: {
      focusId: function () {
        this.formData = { ...this.categoryFilterById };
        this.previewURL = this.formData.bannerPath;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .editModal {
    font-family: "Noto Sans TC", sans-serif;

    .preview {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 100px;
      border: 2px solid #ddd;
      background-color: #eee;
      border-radius: 8px;
      padding: 2rem;
      cursor: pointer;

      h3 {
        margin: 0;
      }

      img {
        width: 100%;
      }
    }

    section {
      margin-top: 50px;
    }

    .modal-btn-group {
      display: grid;
      grid-template-columns: 100px 1fr 100px;
      grid-gap: 4px;

      .btn {
        width: 100px;
      }
    }
  }
</style>
